
document.addEventListener('DOMContentLoaded', function () {
        // Base de données des produits
        const products = {
            presentation: [
                {
                    name: "Lapratic Bois de Bout",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/copie-de-lapratic-bois-de-bout",
                    image: ""
                },
                {
                    name: "Planche à Manches",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-manches",
                    image: ""
                },
                {
                    name: "Planche Oblong by Design",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-oblong-by-design",
                    image: ""
                },
                {
                    name: "Planche Couperet",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-couperet",
                    image: ""
                }
            ],
            jus: [
                {
                    name: "Billot à Poser",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-a-poser",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Planche à Découper",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Billot à Poser 3D 140 ans",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-a-poser-3d-140-ans",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Planche à Découper en Bois de Bout par Eloïse",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper-en-bois-de-bout-par-eloise",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Planche à Découper Personnalisable",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper-personnalisable",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Lapratic Bois de Fil",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/copie-de-lapratic-bois-de-fil",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Plan de Travail Réversible Bois de Bout",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/plan-de-travail-reversible-bois-de-bout",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Billot à Poser Damier",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-a-poser-damier",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Plan de Travail à Poser en Bois Debout de Charme",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/plan-de-travail-a-poser-en-bois-debout-de-charme",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Plan de Travail à Poser Mixte Charme Ardoise",
                    url: "http://chabret.fr/collections/planches-a-decouper/products/plan-de-travail-a-poser-mixte-charme-ardoise",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Planche à Découper Récup Jus by Itinéraire Design",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper-recup-jus-by-itineraire-design",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Planche à Découper Damier",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper-damier",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Billot à Poser Damier 6",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-a-poser-damier-6",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Planche à Découper Damier 2",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper-damier-2",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Planche à Découper Laurine Ronde",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper-laurine-ronde",
                    image: "",
                    rangeCouteaux: false,
                    poignees: true
                },
                {
                    name: "Planche au Bout Rond par Laurine",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-au-bout-rond-par-laurine",
                    image: "",
                    rangeCouteaux: false,
                    poignees: true
                },
                {
                    name: "Billot Rond",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-rond",
                    image: "",
                    rangeCouteaux: false,
                    poignees: true
                },
                {
                    name: "Billot Ovale",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-ovale",
                    image: "",
                    rangeCouteaux: false,
                    poignees: true
                },
                {
                    name: "Planche Trio",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-trio",
                    image: "",
                    rangeCouteaux: true,
                    poignees: true
                },
                {
                    name: "Planche à Pain",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-pain",
                    image: "",
                    rangeCouteaux: true,
                    poignees: false
                },
                {
                    name: "Planche à Pain Design",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-pain-design",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Nouvelle Planche à Découper",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/nouvelle-planche-a-decouper",
                    image: "",
                    rangeCouteaux: false,
                    poignees: true
                }
            ],
            sansJus: [
                {
                    name: "Tranche",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/tranche",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Cut",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/cut",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Geta",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/geta",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Le Doc",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/le-doc",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Billot Barbecue",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-barbecue",
                    image: "",
                    rangeCouteaux: true,
                    poignees: false
                },
                {
                    name: "Le Billot par F. Bauchet",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/le-billot-par-f-bauchet",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Billot V Design Studio Qooq",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-v-design-studio-qooq",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Billot J Design Studio Qooq",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-j-design-studio-qooq",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "La Planche par Kosmoss",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/la-planche-par-kosmoss",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Plan de Travail Réversible",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/copie-de-plan-de-travail-reversible",
                    image: "",
                    rangeCouteaux: false,
                    poignees: true
                },
                {
                    name: "Planche à Découper Gruyère",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper-gruyere",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Planche à Découper Croc",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/planche-a-decouper-croc",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                },
                {
                    name: "Billot à Poser Escalier",
                    url: "https://chabret.fr/collections/planches-a-decouper/products/billot-a-poser-escalier-modele-copie",
                    image: "",
                    rangeCouteaux: false,
                    poignees: false
                }
            ]
        };

        // État du quiz
        let currentQuestion = 1;
        let answers = {};

        // Sélection des éléments
        const questions = {
            1: document.getElementById('question1'),
            2: document.getElementById('question2'),
            3: document.getElementById('question3'),
            4: document.getElementById('question4')
        };
        const resultsSection = document.getElementById('results');
        const progressBar = document.getElementById('progressBar');
        const restartBtn = document.getElementById('restartBtn');

        // Gestion des clics sur les options
        document.querySelectorAll('.option-card').forEach(card => {
            card.addEventListener('click', function() {
                const question = this.closest('.question-section');
                const questionId = question.id;
                
                // Désélectionner toutes les options de cette question
                question.querySelectorAll('.option-card').forEach(c => c.classList.remove('selected'));
                
                // Sélectionner l'option cliquée
                this.classList.add('selected');
                
                // Enregistrer la réponse
                const value = this.dataset.value;
                answers[questionId] = value;
                
                // Attendre un peu avant de passer à la question suivante
                setTimeout(() => {
                    handleQuestionAnswer(questionId, value);
                }, 300);
            });
        });

        // Gestion de la navigation entre questions
        function handleQuestionAnswer(questionId, value) {
            if (questionId === 'question1') {
                if (value === 'presentation') {
                    // Si présentation, on affiche directement les résultats
                    showResults('presentation');
                } else {
                    // Sinon on passe à Q2
                    showQuestion(2);
                }
            } else if (questionId === 'question2') {
                showQuestion(3);
            } else if (questionId === 'question3') {
                showQuestion(4);
            } else if (questionId === 'question4') {
                // Calculer et afficher les résultats
                showResults('decoupe');
            }
        }

        // Afficher une question
        function showQuestion(questionNumber) {
            // Cacher toutes les questions
            Object.values(questions).forEach(q => q.classList.add('hidden'));
            
            // Afficher la question demandée
            questions[questionNumber].classList.remove('hidden');
            
            // Mettre à jour la barre de progression
            currentQuestion = questionNumber;
            updateProgress();
        }

        // Mettre à jour la barre de progression
        function updateProgress() {
            const totalQuestions = 4;
            const progress = (currentQuestion / totalQuestions) * 100;
            progressBar.style.width = progress + '%';
        }

        // Filtrer les produits selon les réponses
        function filterProducts(category) {
            if (category === 'presentation') {
                return products.presentation.slice(0, 4); // On prend les 4 planches de présentation
            }

            // Déterminer la catégorie de base (jus ou sans jus)
            let baseProducts;
            const q2Answer = answers.question2;
            
            if (q2Answer === 'jus' || q2Answer === 'both-jus') {
                baseProducts = products.jus;
            } else {
                baseProducts = products.sansJus;
            }

            // Filtrer selon range-couteaux
            const q3Answer = answers.question3;
            if (q3Answer === 'oui') {
                baseProducts = baseProducts.filter(p => p.rangeCouteaux === true);
            } else if (q3Answer === 'non') {
                baseProducts = baseProducts.filter(p => p.rangeCouteaux === false);
            }
            // Si "peu-importe", on ne filtre pas

            // Filtrer selon poignées
            const q4Answer = answers.question4;
            if (q4Answer === 'oui') {
                baseProducts = baseProducts.filter(p => p.poignees === true);
            } else if (q4Answer === 'non') {
                baseProducts = baseProducts.filter(p => p.poignees === false);
            }
            // Si "peu-importe", on ne filtre pas

            // Prendre 3-5 produits max
            const maxProducts = Math.min(baseProducts.length, 5);
            return baseProducts.slice(0, maxProducts);
        }

        // Afficher les résultats
        function showResults(category) {
            // Cacher toutes les questions
            Object.values(questions).forEach(q => q.classList.add('hidden'));
            
            // Filtrer les produits
            const filteredProducts = filterProducts(category);
            
            // Afficher les produits
            const productGrid = document.getElementById('productGrid');
            productGrid.innerHTML = '';
            
            // Ajouter classe single-product si un seul produit
            if (filteredProducts.length === 1) {
                productGrid.classList.add('single-product');
            } else {
                productGrid.classList.remove('single-product');
            }
            
            filteredProducts.forEach(product => {
                const productCard = document.createElement('div');
                productCard.className = 'product-card';
                
                const imageUrl = product.image || 'https://via.placeholder.com/300x300/e9e1d4/8a623e?text=' + encodeURIComponent(product.name);
                
                productCard.innerHTML = `
                    <img src="${imageUrl}" alt="${product.name}" class="product-image" onerror="this.src='https://via.placeholder.com/300x300/e9e1d4/8a623e?text=Image'">
                    <div class="product-info">
                        <h3 class="product-name">${product.name}</h3>
                        <a href="${product.url}" class="btn-product" target="_blank">Voir le produit</a>
                    </div>
                `;
                
                productGrid.appendChild(productCard);
            });
            
            // Afficher la section résultats
            resultsSection.classList.remove('hidden');
            
            // Mettre la barre de progression à 100%
            progressBar.style.width = '100%';
            
            // Scroller vers les résultats
            resultsSection.scrollIntoView({ behavior: 'smooth' });
        }

        // Redémarrer le quiz
        restartBtn.addEventListener('click', function() {
            // Réinitialiser les réponses
            answers = {};
            currentQuestion = 1;
            
            // Désélectionner toutes les options
            document.querySelectorAll('.option-card').forEach(card => {
                card.classList.remove('selected');
            });
            
            // Cacher les résultats
            resultsSection.classList.add('hidden');
            
            // Afficher la première question
            showQuestion(1);
            
            // Scroller vers le haut
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        // Initialiser
        updateProgress();
   });